import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInterventionCreation } from '../../context/interventionCreationContext';
import TransitionReportBanner from '../Assignment/TransitionReportBanner';

/**
 * Bilan du dernier départ de demandes vers l'affectation, que le geste soit un envoi
 * explicite ou une qualification réussie.
 *
 * L'affichage est celui des lots de l'étape Affectation — même enveloppe de réponse, donc
 * même bandeau, avec son décompte des refus et son lien vers le détail. Seule la phrase
 * de succès est propre à ce geste.
 *
 * Monté sur la seule étape des demandes : un bilan appartient à l'écran où le geste a eu
 * lieu.
 */
export default function SendToAssignmentReportBanner() {
  const { t } = useTranslation();
  const { state, dispatch } = useInterventionCreation();

  const report = state.lastSendToAssignmentReport;

  if (report === null) {
    return null;
  }

  return (
    <TransitionReportBanner
      report={report}
      successMessage={t('interventionCreation.requests.sendToAssignmentReport', {
        count: report.succeededCount
      })}
      onDismiss={() => dispatch({ type: 'dismissSendToAssignmentReport' })}
    />
  );
}
